import { render, staticRenderFns } from "./PageBootcamp.vue?vue&type=template&id=57b396f0&"
import script from "./PageBootcamp.vue?vue&type=script&lang=js&"
export * from "./PageBootcamp.vue?vue&type=script&lang=js&"
import style0 from "./PageBootcamp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports